import _isNil from 'lodash/isNil';
import _isNumber from 'lodash/isNumber';
import _isObject from 'lodash/isObject';
var parse = JSON.parse,
  stringify = JSON.stringify;
var SESSION_STORAGE = 'sessionStorage';
var LOCAL_STORAGE = 'localStorage';
function isStorageAvailable(storageName) {
  var hasWindowObj = typeof window !== 'undefined';
  return hasWindowObj && typeof window[storageName] !== 'undefined';
}
function getStorage(storageName) {
  if (isStorageAvailable(storageName)) {
    return window[storageName];
  }
  throw Error("Storage not available or unknown: ".concat(storageName));
}
var Storage = {
  SESSION_STORAGE: SESSION_STORAGE,
  LOCAL_STORAGE: LOCAL_STORAGE,
  DEFAULT_STORAGE: LOCAL_STORAGE,
  get: function get(key) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var _ref = arguments.length > 2 ? arguments[2] : undefined,
      _ref$storageMechanism = _ref.storageMechanism,
      storageMechanism = _ref$storageMechanism === void 0 ? Storage.DEFAULT_STORAGE : _ref$storageMechanism;
    if (!isStorageAvailable(storageMechanism)) {
      return defaultValue;
    }
    var storedValue = getStorage(storageMechanism).getItem(key);
    if (!_isNil(storedValue)) {
      var parsedValue = parse(storedValue);
      if (!_isNil(parsedValue)) {
        if (_isObject(parsedValue) && Object.prototype.hasOwnProperty.call(parsedValue, 'expiry')) {
          if (new Date().getTime() > parsedValue.expiry) {
            getStorage(storageMechanism).removeItem(key);
            return defaultValue;
          }
          return parsedValue.value;
        }
        return parsedValue;
      }
      return null;
    }
    return defaultValue;
  },
  set: function set(key, value) {
    var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$storageMechanis = _ref2.storageMechanism,
      storageMechanism = _ref2$storageMechanis === void 0 ? Storage.DEFAULT_STORAGE : _ref2$storageMechanis,
      _ref2$expiry = _ref2.expiry,
      expiry = _ref2$expiry === void 0 ? null : _ref2$expiry;
    if (_isNil(value)) {
      return null;
    }
    var finalValue = value;
    if (expiry && _isNumber(expiry) && expiry > 0) {
      finalValue = {
        value: value,
        expiry: new Date().getTime() + expiry
      };
    }
    if (isStorageAvailable(storageMechanism)) {
      return getStorage(storageMechanism).setItem(key, stringify(finalValue));
    }
    return null;
  },
  clear: function clear(key) {
    var storageMechanism = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Storage.DEFAULT_STORAGE;
    if (isStorageAvailable(storageMechanism) && getStorage(storageMechanism).getItem(key)) {
      return getStorage(storageMechanism).removeItem(key);
    }
    return null;
  },
  destroy: function destroy() {
    var storageMechanism = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Storage.DEFAULT_STORAGE;
    if (isStorageAvailable(storageMechanism)) {
      getStorage(storageMechanism).clear();
    }
  }
};
export default Storage;